import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Observer} from 'rxjs';
import { Globals } from '../globals';
import { AuthHttpService } from "./auth-http.service";
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CreateDialogComponent } from "../shared/dialogs/create-dialog/create-dialog.component";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

@Injectable({
  providedIn: 'root'
})
export class AnalisisService {

	sensorsList = [];
	lanesList = [];
	classesList = [];
	monthList = [];
	weekList = [];
	dayList = [];
	sliceList = [];
	timezoneList = [];
	currentDateBeginning = new Date().setHours(0, 0, 0, 0);
	currentDate = new Date();
	dateBefore: any = new Date(this.currentDateBeginning);
	dateToday: any = new Date(this.currentDateBeginning);
	dateAfter: any = new Date();
	//разность между датами
	date_difference = 0;
	date_before_error = false;
	date_after_error = false;
	slice_choosen = false;
	showMinutes = false;
	showMinutesDis = false;
	needReload: boolean;
	minute_min:number;

	// запоминание датчиков проекта для перехода со стр статистики к попапу карты
	projectSensorsGlob = [];

	//запоминание выбраных датчиков через страницы
	selectedSensorsGlobDef = [];
	selectedSensorsGlob = new BehaviorSubject<any>(this.selectedSensorsGlobDef);
	selectedSensors = this.selectedSensorsGlob.asObservable();

	//запоминание датчиков проекта для перехода между компонентами
	sensorsGlobDef = [];
	sensorsGlob = new BehaviorSubject<any>(this.sensorsGlobDef);

	//буфер для выбранных юзером параметров фильтра для сохранения после смены языка
	filter_buffer = {
		'period':{id: null, name: '', list: [], show: true},
		'date_from':'',
		'date_to':'',
		'year':'',
		'months':[],
		'week':'',
		'days':[],
		'hours':[],
		'min':false,
		'interval':'',
		'classes':[],
		'lanes':[],
		'parametres':[],
		'cats':[],
		'types':[]
	};

	//for buffer checking
	def_slice_done = false;
	no_check_min = false;

	//для получения статусов для отчетов
	status_report = [];
	report_ready = false;
	error_data:string;
	sensor_uptime_arr = [];
	temp_date_before = [];
	temp_date_after = [];

	//для диалога экспорта
	uptime_loading = false;

	//класс для отслеживание кликов по ссылкам сегодня, вчера, неделю назад
	date_links = [
		{
			"name":"today",
			"selected": false,
			"clicked": false
		},
		{
			"name":"yesterday",
			"selected": false,
			"clicked": false
		},
		{
			"name":"week_ago",
			"selected": false,
			"clicked": false
		},
		{
			"name":"lastweek",
			"selected": false,
			"clicked": false
		},
		{
			"name":"lastmonth",
			"selected": false,
			"clicked": false
		}
	]
  public moreThanThirtyOneDay: boolean;

	dateLinks(e: string) {
		let date = new Date();
		let other_date: number;
		switch (e) {
		  case 'today':
			this.date_links[0].selected = true;
			this.date_links[1].selected = false;
			this.date_links[2].selected = false;
			this.date_links[3].selected = false;
			this.date_links[4].selected = false;
			date = new Date();
			this.dateBefore = new Date(date.setHours(0, 0, 0, 0));
			this.dateAfter = new Date();
      this.Globals.calendarInterval = true;
			break;

		  case 'yesterday':
			this.date_links[0].selected = false;
			this.date_links[1].selected = true;
			this.date_links[2].selected = false;
			this.date_links[3].selected = false;
			this.date_links[4].selected = false;
			date.setDate(date.getDate() - 1);
			this.dateBefore = new Date(date.setHours(0, 0, 0, 0));
			this.dateAfter = new Date(date.setHours(23, 59, 59, 999));
      this.Globals.calendarInterval = true;
			break;

		  case 'weekago':
			this.date_links[0].selected = false;
			this.date_links[1].selected = false;
			this.date_links[2].selected = true;
			this.date_links[3].selected = false;
			this.date_links[4].selected = false;
			date.setDate(date.getDate() - 7);
			this.dateBefore = new Date(date.setHours(0, 0, 0, 0));
			this.dateAfter = new Date();
      this.Globals.calendarInterval = true;
			break;

			case 'lastweek':
				this.date_links[0].selected = false;
				this.date_links[1].selected = false;
				this.date_links[2].selected = false;
				this.date_links[3].selected = true;
				this.date_links[4].selected = false;
				this.dateAfter = date;
				other_date = new Date(this.dateAfter).setDate(date.getDate() - 7);
				this.dateBefore = other_date;
        this.Globals.calendarInterval = true;
			  break;

			  case 'lastmonth':
				this.date_links[0].selected = false;
				this.date_links[1].selected = false;
				this.date_links[2].selected = false;
				this.date_links[3].selected = false;
				this.date_links[4].selected = true;
				this.dateAfter = date;
				other_date = new Date(this.dateAfter).setDate(date.getDate() - 31);
				this.dateBefore = other_date;
          this.Globals.calendarInterval = true;
			  break;

		  case 'picked':
			this.date_links[0].selected = false;
			this.date_links[1].selected = false;
			this.date_links[2].selected = false;
			this.date_links[3].selected = false;
			this.date_links[4].selected = false;
			break;
		}
    localStorage.setItem('consolidateDateBefore', this.dateBefore);
	  }
	public curr_date: any;

	constructor(
    public Globals: Globals,
    private http: AuthHttpService,
    public dialog: MatDialog
  ) {
		this.curr_date = new Date();
	}

	/**функция для получения времени работоспособности датчика или датчиков для отчетов
	* @sensors - массив датчиков для которых хотим получить статус
	*/

	getSensorsUptime(sensors: any[]): Observable<any>{
		this.sensor_uptime_arr = [];

	  	let date_before_utc = this.convertDateToUTC(new Date(this.dateBefore));
		  let date_after_utc = this.convertDateToUTC(new Date(this.dateAfter));

	  	//задаем параметры для запроса
	    let sensor_ids_str = JSON.stringify(sensors);
	    let params: any = {
	      'date_before': date_before_utc,
			  'date_after': date_after_utc,
			  'sensor_ids': sensor_ids_str
	    };

		//создадим структуру выходного массива по датчикам с их интервалами статусов и массива с набором аптаймов по дням
		sensors.forEach(s=>{
			this.sensor_uptime_arr.push({
				"sensor_id":s,
				"intervals":[],
				"days_uptime":[],
        		"active_sensors":[],
				"idle_time":"",
				"uptime_per":0,
				"consistency_per":0,
				"no_data_days":0,
				"no_data":false
			});
		});

	  	//получаем отчет
	  	return new Observable((observer: Observer<any>) => {
	  		// this.uptime_loading = true;
	  		this.http.post('/api/status_log', params).subscribe(res => {
				let status_report = res.body;
				//далее надо посчитать общий uptime в %, вывести некое среднее из данных uptime каждого дня
				//для этого берем каждый день как 100, затем суммируем проценты uptime за день, затем получаем, сколько % составляет сумма процентов от 100 * кол-во дней days_count = per_total

				//далее заполним его интервалами со статусом 0
				//console.log('status_report', status_report);
				if(Boolean(status_report.data)){

					status_report.data.forEach((day: { day_data: any[]; })=>{

						day.day_data.forEach(sensor=>{

							//нужно добавить "no_data":true если в каждом датчика
							//находится только  объекты со статус кодом -1 и -2

							let uptime_index_zero = sensor.sensor_data.findIndex((d: { status_code: number; })=>d.status_code == 0);
							let uptime_index_one = sensor.sensor_data.findIndex((d: { status_code: number; })=>d.status_code == 1);
							let uptime_index_two = sensor.sensor_data.findIndex((d: { status_code: number; })=>d.status_code == 2);


							let found_sensor = this.sensor_uptime_arr.find(s=>s.sensor_id == sensor.sensor_id);
							if(Boolean(found_sensor)){
								if(uptime_index_zero == -1 && uptime_index_one == -1 && uptime_index_two == -1){
									found_sensor.no_data_days++ ;
								}else{
									//чтобы посчитать недоступность датчика, складываем interval_duration у полученных интервалов
									sensor.sensor_data.forEach((interval: { status_code: number; })=>{
										if(interval.status_code == 0){
											found_sensor.intervals.push(interval);
										}
										// Для подсчета консистентность
										if (interval.status_code == 1) {
											found_sensor.active_sensors.push(Math.floor(sensor.sensor_uptime_per));
										}
										let dur_total_sec:number = 0;
										for (var i = 0; i < found_sensor.intervals.length; ++i) {
											// перводим продолжительность интервала в секунды
											let int = found_sensor.intervals[i].interval_duration;
											int = int.slice(11)
											let int_dur_parts = int.split(":")
											let int_dur_sec = (Number(int_dur_parts[0]) * 3600) + (Number(int_dur_parts[1]) * 60) + Number(int_dur_parts[2]);
											dur_total_sec += int_dur_sec;
											//console.log('dur_total_sec',dur_total_sec);

										}
										//переводим из секунд в нужный строчный формат
										let pad = (num: string | number) =>{
											if(Number(num) < 10) {
												return "0" + num;
											}else {
												return "" + num;
											}
										}
										let dur_total_str = [
											pad(Math.floor(dur_total_sec/3600)),
											pad(Math.floor(dur_total_sec/60)%60)
										].join(":");

										found_sensor.idle_time = dur_total_str;
									});

									//теперь должны получить для определенного датчика за период бесперебойную работу uptime_per и время простоя idle_time
									if(sensor.sensor_uptime_per == null){
										sensor.sensor_uptime_per = 0;
									}
									found_sensor.days_uptime.push(Math.floor(sensor.sensor_uptime_per));
								}
							}
						});
					});

					// теперь получаем средний процент uptime за период
					this.sensor_uptime_arr?.forEach(sensor=>{

						//выставляем no_data по кол-ву дней без данных
						if(sensor.no_data_days == status_report.data.length){
							sensor.no_data = true;
						}else{
							sensor.no_data = false;
						}

						if(!sensor.no_data){
							let consistency_count = 0;
							let total_consistency_num = 0;
							let days_count = sensor.days_uptime.length;
							let total_per = days_count * 100;
							let total_uptime_num;
							if (sensor.days_uptime.length) {
                total_uptime_num = sensor.days_uptime.reduce((a: any, b: any) => a + b);
              }
							if (sensor.active_sensors.length) {
								consistency_count = sensor.active_sensors.length;
								total_consistency_num = sensor.active_sensors.reduce((a: any,b: any) => a + b);
								sensor.consistency_per = ( total_consistency_num / consistency_count).toFixed(2);
							} else {
								sensor.consistency_per = '0.00';
							}

							sensor.uptime_per = (total_uptime_num * 100 / total_per).toFixed(2);

							//и форматируем время простоя в удобочитаемую строку
							let idle_time_arr =  sensor.idle_time.split(":");

							//если кол-во часов больше 24, добавляем дни
							if(Number(idle_time_arr[0]) > 24 ){

								//добавляем число дней в начало массива и меняем кол-во часов
								let days_num:number;
								days_num = Math.floor((Number(idle_time_arr[0]) / 24));

								idle_time_arr.unshift(days_num);
								let old_hours = Number(idle_time_arr[1]);
								let new_hours = old_hours - idle_time_arr[0] * 24;
								idle_time_arr[1] = new_hours.toString();
								idle_time_arr[0] = idle_time_arr[0].toString();
							}
							// и добавляем в наш массив значение времени в виде массива, из которого будем выводить в отчете
							sensor['idle_time_arr'] = idle_time_arr;
						}else{
							sensor['idle_time_arr'] = [];
						}

					});
					//console.log('service sensor_uptime_arr',this.sensor_uptime_arr);
		  			observer.next(this.sensor_uptime_arr);
	            	observer.complete();
	            	this.uptime_loading = false;
				}else{
					this.uptime_loading = false;
				}

          	}, error => {
		        if (error.status !== 401 && error.status !== 403 && error.status !== 504) {
            this.Globals.error = false;
            this.dialog.open(CreateDialogComponent, <MatDialogConfig>{
               data: {
                  act: 'error',
                  text: this.error_data,
                  icon_class: 'dialog-icon-warning'
               }
				  	});
		        }
	    	});
	  	});
	}

	//функция для обновления списка глобальных датчиков проекта
	changeSensorsData(newData: any) {
		this.sensorsGlob.next(newData);
		this.sensorsGlobDef = newData;
	}
	//запоминание выбраных датчиков через страницы
	//функция для обновления списка отмеченных датчиков из компонентов
	changeData(newData: any) {
		this.selectedSensorsGlob.next(newData);
		this.selectedSensorsGlobDef = newData;
	}

	/**функция для сортировки датчиков проекта по статусу и по имени внутри статуса
	* @param sensors_array - входящий список датчиков
	**/
	sortSensorsNameStatus(sensors_array){
        //требуется отсортировать по статусу и по имени внутри статусов
        // для этого создадим массивы по статусам, отсортируем в них по имени, а затем объединим

        let status_green_arr = [];
        let status_red_arr = [];
        let status_yellow_arr = [];
        let status_grey_arr = [];
        let status_blue_arr = [];

        JSON.parse(sensors_array).forEach((sensor: { status_v: any; })=>{
            switch (sensor.status_v) {
                case 0:
                    status_red_arr.push(sensor);
                    break;
                case 1:
                    status_green_arr.push(sensor);
                    break;
                case 2:
                    status_yellow_arr.push(sensor);
                    break;
                case 3:
                    status_grey_arr.push(sensor);
                  break;
                case 4:
                  status_blue_arr.push(sensor);
                  break;
            }
        });

        //сортируем массивы по имени если в массивах больше 1 элемента
        if(status_red_arr.length > 1 ){
            status_red_arr.sort((a, b) =>a.name.localeCompare(b.name));
        }
        if(status_green_arr.length > 1 ){
            status_green_arr.sort((a, b) =>a.name.localeCompare(b.name));
        }
        if(status_yellow_arr.length > 1 ){
            status_yellow_arr.sort((a, b) =>a.name.localeCompare(b.name));
        }
        if(status_grey_arr.length > 1 ){
            status_grey_arr.sort((a, b) =>a.name.localeCompare(b.name));
        }
        if(status_blue_arr.length > 1 ){
          status_blue_arr.sort((a, b) =>a.name.localeCompare(b.name));
        }

        //объединяем в один и меняем предыдущий массив датчиков
        let sorted_arr = [];
        sorted_arr = [...status_green_arr, ...status_yellow_arr,  ...status_red_arr, ...status_blue_arr, ...status_grey_arr];
        sensors_array = JSON.parse(JSON.stringify(sorted_arr));
        return 	sensors_array;
	}

	/**
	 * функция проверки полей периода, чтобы начало не было больше конца
	 * также дизаблим ненужные варианты нарезки
	 * @param dateBefore - дата начала периода
	 * @param dateAfter - дата окончания периода
	 * @param project - для диалога проекта, чтобы дата после не сбрасывалась
	 */
	correctPeriod(dateBefore: string | number | Date, dateAfter: string | number | Date, project:boolean = false) {

		//если дата корректна, убираем ошибки
		this.date_before_error = false;
		this.date_after_error = false;

		this.checkDateLinks([dateBefore], 'date-before');
		this.checkDateLinks([dateAfter], 'date-after');

		let start = new Date(dateBefore).getTime();
		let finish = new Date(dateAfter).getTime();
		let current = new Date();
		let minute_ms = 60000;
		let five_minute_ms = 300000;
		let ten_minute_ms = 600000;
		let fifteen_minute_ms = 900000;
		let thirty_minute_ms = 1800000;
		let hour_ms = 3600000;
		let day_ms = 86400000;
		let week_ms = 604800000;
		let month_ms = 2678400000;
		let min_disable_ms = 30000000;
		let five_min_disable_ms = 150000000;
		let ten_min_disable_ms = 300000000;
		let fifteeen_min_disable_ms = 450000000;
		let thirty_min_disable_ms = 900000000;
		let hour_disable_ms = 2678400000;
		let day_disable_ms = 31536000000;
		let week_disable_ms = 302400000000;
		let month_disable_ms = 1209600000000;

		this.date_difference = finish - start;
		//console.log('delaet this.date_before_error', this.date_before_error);
		//проверяем заполнен ли буфер выбором минут

		if (Boolean(this.filter_buffer.interval)) {
			this.no_check_min = true;
		}

		// закомментил условие про буффер, так как оно давало ошибку при выборе даты
		// if(this.dateBefore != this.filter_buffer.date_from){

		// если дата «после» или дата «до» больше текущей даты, ставим красный бордер
		this.date_before_error = start > this.curr_date.getTime();
		this.date_after_error = finish > this.curr_date.getTime() || finish < 0;
		this.moreThanThirtyOneDay = finish - start > 31 * 24 * 60 * 60 * 1000;

		// для даты из создания проекта
		if (project) {
			this.date_before_error = start > finish;
		}

		//вариант без сброса даты а обводом красной рамкой
		this.date_after_error = start > finish;
		this.date_after_error = !isNaN(finish) ? this.date_after_error : isNaN(finish);

		//сверяем с периодом по умолчанию и дизаблим ненужные интервалы нарезки
		if (!project && this.sliceList.length > 0) {
			this.sliceList.forEach((slice) => {
				slice['disabled'] = false
			});

			//интервал дат меньше минуты
			if (this.date_difference <= minute_ms) {
				this.sliceList.forEach((slice) => {
					if (slice['id'] != 4) {
						slice['disabled'] = true;
						if(!this.no_check_min){
							slice['checked'] = false;
						}
					}
					else {
						if(!this.no_check_min){
							slice['checked'] = true;
						}
					}
				});
				this.showMinutes = true;
			}
			//интервал дат больше минуты но меньше 5 мин
			if (this.date_difference > minute_ms && this.date_difference <= five_minute_ms) {
				this.sliceList.forEach((slice) => {
					if (slice['id'] < 4 || slice['id'] > 5) {
						slice['disabled'] = true;
						if(!this.no_check_min){
							slice['checked'] = false;
						}
					}
					if(!this.no_check_min){
						slice['checked'] = slice['id'] == 5;
					}
				});
				this.showMinutes = true;
			}
			//интервал дат больше 5 мин но меньше 10 мин
			if (this.date_difference > five_minute_ms && this.date_difference <= ten_minute_ms) {
				this.sliceList.forEach((slice) => {
					if (slice['id'] < 4 || slice['id'] > 6) {
						slice['disabled'] = true;
						if(!this.no_check_min){
							slice['checked'] = false;
						}
					}
					if(!this.no_check_min){
						slice['checked'] = slice['id'] == 6;
					}
				});
				this.showMinutes = true;
			}
			//интервал дат больше 10 мин но меньше 15 мин
			if (this.date_difference > ten_minute_ms && this.date_difference <= fifteen_minute_ms) {
				this.sliceList.forEach((slice) => {
					if (slice['id'] < 4 || slice['id'] > 7) {
						slice['disabled'] = true;
						if(!this.no_check_min){
							slice['checked'] = false;
						}
					}
					if(!this.no_check_min){
						slice['checked'] = slice['id'] == 7;
					}
				});
				this.showMinutes = true;
			}
			//интервал дат больше 15 мин но меньше 30 мин
			if (this.date_difference > fifteen_minute_ms && this.date_difference <= thirty_minute_ms) {
				this.sliceList.forEach((slice) => {
					if (slice['id'] < 4 || slice['id'] > 8) {
						slice['disabled'] = true;
						if(!this.no_check_min){
							slice['checked'] = false;
						}
					}
					if(!this.no_check_min){
						slice['checked'] = slice['id'] == 8;
					}
				});
				this.showMinutes = true;
			}
			//интервал дат больше 30 мин, но меньше часа
			if (this.date_difference > thirty_minute_ms && this.date_difference <= hour_ms) {
				this.sliceList.forEach((slice) => {
					if (slice['id'] < 3) {
						slice['disabled'] = true;
						if(!this.no_check_min){
							slice['checked'] = false;
						}
					}
					if(!this.no_check_min){
						slice['checked'] = slice['id'] == 3;
					}
				});
				if(!this.no_check_min){
					this.showMinutes = false;
				}
			}
			//интервал дат больше часа, но меньше суток
			if (this.date_difference > hour_ms && this.date_difference <= day_ms) {
				this.sliceList.forEach((slice) => {
					if (slice['id'] < 2) {
						slice['disabled'] = true;
						if(!this.no_check_min){
							slice['checked'] = false;
						}
					}
					if(!this.no_check_min){
						slice['checked'] = slice['id'] == 3;
					}
				});
				if(!this.no_check_min){
					this.showMinutes = false;
				}
			}
			//интервал дат больше суток, но меньше недели
			if (this.date_difference > day_ms && this.date_difference <= week_ms) {
				this.sliceList.forEach((slice) => {
					if (slice['id'] < 1) {
						slice['disabled'] = true;
						if(!this.no_check_min){
							slice['checked'] = false;
						}
					}
					if(!this.no_check_min){
						slice['checked'] = slice['id'] == 2;
					}
				});
				if(!this.no_check_min){
					this.showMinutes = false;
				}
			}
			//интервал дат больше недели, но меньше месяца
			if (this.date_difference > week_ms && this.date_difference <= month_ms) {
				this.sliceList.forEach((slice) => {

					if (slice['id'] < 0) {
						slice['disabled'] = true;
						if(!this.no_check_min){
							slice['checked'] = false;
						}
					}
					if(!this.no_check_min){
						slice['checked'] = slice['id'] == 1;
					}
				});
				if(!this.no_check_min){
					this.showMinutes = false;
				}
			}

			//интервал дат больше месяца, но меньше двух -  ставим интервал день
			if (this.date_difference > month_ms && this.date_difference <= month_ms * 2) {
				this.sliceList.forEach((slice) => {
					if (slice['id'] < 0) {
						slice['disabled'] = true;
						if(!this.no_check_min){
							slice['checked'] = false;
						}
					}
					if(!this.no_check_min){
						slice['checked'] = slice['id'] == 2;
					}
				});
				if(!this.no_check_min){
					this.showMinutes = false;
				}
			}

			//интервал дат больше 2 месяцев, но меньше 4 -  ставим интервал неделю, дизаблим интервалы меньше дня
			if (this.date_difference > month_ms * 2 && this.date_difference <= month_ms * 4) {
				this.sliceList.forEach((slice) => {
					if (slice['id'] > 2) {
						slice['disabled'] = true;
						if(!this.no_check_min){
							slice['checked'] = false;
						}
					}
					if(!this.no_check_min){
						slice['checked'] = slice['id'] == 1;
					}
				});
				if(!this.no_check_min){
					this.showMinutes = false;
				}
			}
			//интервал дат больше 4 месяцев, ставим интервал месяц, дизаблим интервалы меньше дня
			if (this.date_difference > month_ms * 2 && this.date_difference <= month_ms * 4) {
				this.sliceList.forEach((slice) => {
					if (slice['id'] > 2) {
						slice['disabled'] = true;
						if(!this.no_check_min){
							slice['checked'] = false;
						}
					}
					if(!this.no_check_min){
						slice['checked'] = slice['id'] == 0;
					}
				});
				if(!this.no_check_min){
					this.showMinutes = false;
				}
			}


			//поставили условие, чтобы для периодов не больше 2 суток были активны все интервалы нарезки
			if(this.date_difference > day_ms*2){

				// интервал дат больше 500 мин (дизаблим минуты, график ломается, если получать за такой период по минутам)
				if (this.date_difference > min_disable_ms) {
					this.sliceList.forEach((slice) => {
						if (slice['id'] == 4) {
							slice['disabled'] = true;
						}
					});
				}
				// интервал дат больше 5x500 мин (дизаблим 5 мин)
				if (this.date_difference > five_min_disable_ms) {
					this.sliceList.forEach((slice) => {
						if (slice['id'] == 5) {
							slice['disabled'] = true;
						}
					});
				}


				// интервал дат больше 10x500 мин (дизаблим 10 мин)
				if (this.date_difference > ten_min_disable_ms) {
					this.sliceList.forEach((slice) => {
						if (slice['id'] == 6) {
							slice['disabled'] = true;
						}
					});
				}
				// интервал дат больше 15x500 мин (дизаблим 15 мин)
				if (this.date_difference > fifteeen_min_disable_ms) {
					this.sliceList.forEach((slice) => {
						if (slice['id'] == 7) {
							slice['disabled'] = true;
						}
					});
				}
				// интервал дат больше 30x500 мин (дизаблим 30 мин)
				if (this.date_difference > thirty_min_disable_ms) {
					this.sliceList.forEach((slice) => {
						if (slice['id'] == 8) {
							slice['disabled'] = true;
						}
					});
				}


			}

			// интервал дат больше 500 часов (дизаблим 1 час)
			if (this.date_difference > hour_disable_ms) {
				this.sliceList.forEach((slice) => {
					if (slice['id'] == 3) {
						slice['disabled'] = true;
					}
				});
			}
			// интервал дат больше 500 дней (дизаблим день)
			if (this.date_difference > day_disable_ms) {
				this.sliceList.forEach((slice) => {
					if (slice['id'] == 2) {
						slice['disabled'] = true;
					}
				});
			}
			// интервал дат больше 500 недель (дизаблим неделя)
			if (this.date_difference > week_disable_ms) {
				this.sliceList.forEach((slice) => {
					if (slice['id'] == 1) {
						slice['disabled'] = true;
					}
				});
			}
			// интервал дат больше 500 месяцев (дизаблим месяц)
			if (this.date_difference > month_disable_ms) {
				this.sliceList.forEach((slice) => {
					if (slice['id'] == 0) {
						slice['disabled'] = true;
					}
				});
			}
			//console.log('sliceList',this.sliceList);

			// отключаем период нарезки год если он есть и если интервал даты меньше месяца
			const yearIndex = this.sliceList.findIndex(slice => slice.id == 9);
			if (yearIndex != -1) {
				this.sliceList[yearIndex].checked = false;
				if (this.date_difference >= month_ms) {
					this.sliceList[yearIndex].disabled = false;
				} else {
					this.sliceList[yearIndex].disabled = true;
				}
			}

			//дизаблим выбиралку минут, если все варианты минут задизаблены
			let point = 0;
			this.sliceList.slice(4).forEach((s) => {
				if (s.disabled) {
					point++;
				}
			});
			if (point == this.sliceList.slice(4).length) {
				this.showMinutesDis = true;
				if(!this.no_check_min){
					this.showMinutes = false;
				}

			}
			else {
				this.showMinutesDis = false;
			}

			// проверим все незадизабленные аттрибуты и если они есть
			// поставим checked для первого незадизабленного

			//@yubox сначала снимем checked со всех
			this.sliceList.forEach(slice=>{
				slice.checked = false;
			});

			const check = this.sliceList.filter(period => period.disabled == false).every(period => period.checked == false);
			if (check) {
				let firstEl = this.sliceList.find(period => period.disabled == false);
				if (Boolean(firstEl)) firstEl.checked = true;
			}
		}
    if (typeof dateBefore === 'string') {
      localStorage.setItem('consolidateDateBefore', dateBefore);
    }
	}

	checkDateLinks(e,type){
		let received_date = e[0].length < 19 ? e[0] + ' 00:00:00' : e[0];
		let day_check_picked = dayjs(received_date, 'DD.MM.YYYY HH:mm:ss', true).isValid();
		const pattern = /(\d{1,2})\.(\d{1,2})\.(\d{4}) (\d{1,2})\:(\d{1,2})\:(\d{1,2})/;
		let date;
		if(day_check_picked){


			date = received_date.replace(pattern,'$3/$2/$1 $4:$5:$6')
			let date_mc = new Date(date).getTime();
			let start;
			let finish;
			//console.log('received_date', date_mc);
			switch (type) {
				case 'date-before':
					start = date_mc;
					finish = new Date(this.dateAfter).getTime();
					break;
				case 'date-after':
					start = new Date(this.dateBefore).getTime();
					finish = date_mc;
					break;
			}

			let current = new Date();


			//проверяем соответствие дат интервалам "сегодня", "вчера", "неделю назад" и если интервалы не соответствуют, снимаем активность ссылок

			//сегодня
			let today_before = new Date(current.setHours(0, 0, 0, 0));

			if(start !== today_before.getTime() || finish + 6000 < current.getTime()){
				this.date_links[0].selected = false;
			}else{
				this.date_links[0].selected = true;
			}

			//вчера
			let yesterday_before = new Date();
			yesterday_before.setDate(yesterday_before.getDate() - 1);
			yesterday_before = new Date(yesterday_before.setHours(0, 0, 0, 0));

			let yesterday_after = new Date(yesterday_before);
			yesterday_after = new Date(yesterday_after.setHours(23, 59, 59, 999));

			if(start !== yesterday_before.getTime() || finish + 999 !== yesterday_after.getTime()){
				this.date_links[1].selected = false;
			}else{
				this.date_links[1].selected = true;
			}

			//неделю назад
			let weekago_before = new Date();
			weekago_before.setDate(weekago_before.getDate() - 7);

			let weekago_after = new Date(weekago_before);
			weekago_before = new Date(weekago_before.setHours(0, 0, 0, 0));
			weekago_after = new Date(weekago_after.setHours(23, 59, 59, 999));

			if(start !== weekago_before.getTime() || finish + 999 !== weekago_after.getTime()){
				this.date_links[2].selected = false;
			}else{
				this.date_links[2].selected = true;
			}

			//последняя неделя (только для диаграммы статусов)
			let lastweek_before = new Date();
			lastweek_before.setDate(lastweek_before.getDate() - 7);

			let lastweek_after = new Date(lastweek_before);
			lastweek_after.setDate(lastweek_before.getDate() + 7);
			// lastweek_before = new Date(lastweek_before.setHours(0, 0, 0, 0));
			// lastweek_after = new Date(lastweek_after.setHours(23, 59, 59, 999));

			if(
				start + 60000 < lastweek_before.getTime() ||
				start - 60000 > lastweek_before.getTime() ||
				finish + 60000 < lastweek_after.getTime()){
				this.date_links[3].selected = false;
			}else{
				this.date_links[3].selected = true;
			}

			//последний месяц (только для диаграммы статусов)
			let lastmonth_before = new Date();
			lastmonth_before.setDate(lastmonth_before.getDate() - 31);

			let lastmonth_after = new Date(lastmonth_before);
			lastmonth_after.setDate(lastmonth_before.getDate() + 31);
			if(
				start + 60000 < lastmonth_before.getTime() ||
				start - 60000 > lastmonth_before.getTime() ||
				finish + 60000 < lastmonth_after.getTime()){
				this.date_links[4].selected = false;
			}else{
				this.date_links[4].selected = true;
			}

		}
		//
	}

    /**
     * Put a red border if the date is incorrect.
     * @param type_date_arr
     * @param from_analysis
     */
    setDateBorders(type_date_arr: any[], from_analysis?: boolean) {
		//console.log('setDateBorders works', type_date_arr);
		let start = new Date(this.dateBefore).getTime();
		let finish = new Date(this.dateAfter).getTime();
		let current = new Date().getTime();
		let lastCorrectDate = this.curr_date.getTime() - (24  * 60 * 60 * 1000);


        let received_date = type_date_arr[0].length < 19 ? type_date_arr[0] + ' 00:00:00' : type_date_arr[0];

        let index = type_date_arr[1];
        let day_check_picked = dayjs(received_date, 'DD.MM.YYYY HH:mm:ss', true).isValid();

		const pattern = /(\d{1,2})\.(\d{1,2})\.(\d{4}) (\d{1,2})\:(\d{1,2})\:(\d{1,2})/;
        let date = received_date.replace(pattern,'$3/$2/$1 $4:$5:$6')
		let date_mc = new Date(date).getTime();

       if (!day_check_picked) {
            switch (index) {
              case 1:
                this.date_before_error = true;
                break;
              case 2:
                this.date_after_error = true;
                break;
            }
        } else {
            switch (index) {
              case 1:
				if(date_mc>finish){
					this.date_before_error = true;
					//console.log('setDateBorders should red border')
				} else {
					this.date_before_error = date_mc > this.curr_date.getTime();
				}
                break;
              case 2:
				if( date_mc < start){
					this.date_after_error = true;
				} else {
					this.date_after_error = date_mc > this.curr_date.getTime();
				}
                break;
            }
        }


		//ставим красный бордер, если у проекта неправильная дата

      // I wrote this separately, this is only if the date is taken from the Primary Data Analysis page. Sensor report.
      if (from_analysis) {
        //const pattern = /(\d{1,2})\.(\d{1,2})\.(\d{4}) (\d{1,2})\:(\d{1,2})\:(\d{1,2})/;
        //let date = received_date.replace(pattern,'$3/$2/$1 $4:$5:$6')
        let today = this.curr_date;
        let current_date = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
        let received = new Date(date);
        this.date_after_error = received.getTime() > current_date.getTime();
      }
    }
	correctDate(num: any) {

		switch (num) {
			case 1:
				if (this.temp_date_after[1] == 1 && !isNaN(new Date(this.dateBefore).getTime()) && !isNaN(new Date(this.temp_date_before[0]).getTime())) {
					this.date_before_error = false;
				}
				else {
					this.date_before_error = true;
				}
				break;
			case 2:
				if (this.temp_date_after[1] == 2 && !isNaN(new Date(this.dateAfter).getTime()) && !isNaN(new Date(this.temp_date_after[0]).getTime())) {
					this.date_after_error = false;
				}
				else {
					this.date_after_error = true;
				}
				break;
		}
	}
	//выбор интервала нарезки
	chooseSlice(id: number, min = '') {
		let min_en_list = [];
		let total = this.sliceList.length;
		if (min == 'min') {
			this.showMinutes = !this.showMinutes;
			this.sliceList.forEach(slice => {
				slice.checked = false;
				if (slice.id > 3 && !slice.disabled) {
					min_en_list.push(slice);
				}
			});
		}
		this.slice_choosen = true;

		this.sliceList.forEach((slice, j) => {

			slice.checked = j == id;
			//когда выбрана вкладка минуты, находим последний незадизабленный элемент и отмечаем его
			if (min == 'min') {
				//находим в списке незадизабленных элемент с максимальным id
				min_en_list.sort((a, b) => b.id - a.id);
				let target_id = total;
				if (min_en_list.length > 0) {
					target_id = min_en_list[0].id;
				}
				if (target_id <= total && slice.id == target_id) {
					slice.checked = true;
				}
			}

			if (j < 4 && slice.checked) {
				this.showMinutes = false;
			}
		});
		if(Boolean(min_en_list[0])){
			this.minute_min = min_en_list[0].id;
		}
	}
	defaultSlice() {
		this.def_slice_done = true;
		this.dateBefore = new Date(new Date().setHours(0, 0, 0, 0));
		this.dateAfter = new Date();
		if (this.sliceList.length > 0) {
			this.sliceList.map((s, i) => {

				s.disabled = i < 2;
				if (i == 2) {
					s.checked = true;
				}
			});
		}
	}
	//функция для перевода даты из формата базы в формат 05.12.2019
	convertDate(date) {
		date = date.replace(' ', 'T').slice(0, 19);
		let sdate = new Date(date);
		let smonth = ("0" + (sdate.getMonth() + 1)).slice(-2);
		let sday = ("0" + (sdate.getDate() + 1)).slice(-2);
		let cdate = sday + '.' + smonth + '.' + sdate.getFullYear();
		return cdate;
	}
	checkProj() {
		if (this.sensorsGlobDef.length == 0) {
			this.needReload = true;
			return;
		}
		this.sensorsGlobDef.forEach(s => {
			if (s.projects[0].projects_id == this.Globals.select_project) {
				this.needReload = false;
				return;
			} else {
				this.needReload = true;
				return;
			}
		});
	}
	cleanSensorLists() {
		this.projectSensorsGlob = [];
		this.changeData([]);
		this.changeSensorsData([]);
	}


	/**
	 * является ли период между startDate и endDate в промежутке последних 24 часов от сейчас
	 * если да то возвращает true, иначе false
	 * @param {Date} startDate - начальный период
	 * @param {Date} endDate - конечный период
	 */
	isLast24h(startDate: Date | string | number, endDate: Date | string | number): boolean {
		if (typeof startDate == 'string' || typeof startDate == 'number') startDate = new Date(startDate);
		if (typeof endDate == 'string' || typeof endDate == 'number') endDate = new Date(endDate);

		const today = new Date();
		const difBefore = (today.getTime() - startDate.getTime()) / 1000 / 60 / 60;
		const difAfter = (today.getTime() - endDate.getTime()) / 1000 / 60 / 60;
		return !(difBefore > 24 && difAfter > 24);
	}

	/**
	 * является ли период между startDate и endDate в промежутке последнего часа от сейчас
	 * если да то возвращает true, иначе false
	 * @param {Date} startDate - начальный период
	 * @param {Date} endDate - конечный период
	*/
	isLastH(startDate: Date | string | number, endDate: Date | string | number): boolean {
		if (typeof startDate == 'string' || typeof startDate == 'number') startDate = new Date(startDate);
		if (typeof endDate == 'string' || typeof endDate == 'number') endDate = new Date(endDate);

		const today = new Date();
		const difBefore = (today.getTime() - startDate.getTime()) / 1000 / 60 / 60;
		const difAfter = (today.getTime() - endDate.getTime()) / 1000 / 60 / 60;
		return !(difBefore > 1 && difAfter > 1);
	}

	/**
	 * сдвинет даты на 24 часа назад и вернет их
 	*/
	public setDateBefore24H(dateBefore: Date, dateAfter: Date): { 'dateBeforeNew': any, 'dateAfterNew': any } {

		// поставим как дату по умолчанию, момент на 24 часа назад.
		dateAfter = new Date(new Date().setDate(new Date().getDate() - 1));
		dateBefore = new Date(new Date().setDate(new Date().getDate() - 2));

		return { 'dateBeforeNew': dateBefore, 'dateAfterNew': dateAfter };

	}

		/**
	 * сдвинет даты на час назад и вернет их
 	*/
	 public setDateBeforeH(dateBefore: string | number | Date, dateAfter: Date): { 'dateBeforeNew': any, 'dateAfterNew': any } {

		dateAfter = new Date();
		dateAfter.setHours(dateAfter.getHours() - 1);
		dateBefore = new Date(dateBefore);
		dateBefore.setHours(dateBefore.getHours() - 2);

		return { 'dateBeforeNew': dateBefore, 'dateAfterNew': dateAfter };
	}

    convertDateToUTC(date:Date) {
		let time_zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
		//console.log('time_zone',time_zone);
        let local_date =
            new Date(
                date.getUTCFullYear(),
                date.getUTCMonth(),
                date.getUTCDate(),
                date.getUTCHours(),
                date.getUTCMinutes(),
                date.getUTCSeconds()
            ).toLocaleString('ru-RU', { timeZone: time_zone })
            //console.log('time to convert', local_date);
            let conv_time:string;
            //доработка под мак
            if(local_date.includes('/')){
                conv_time = local_date.replace(/\//g, '.');
                //console.log('time converted', conv_time)
            }else conv_time = local_date;
        return  conv_time
    }

	//функция преобразует дату в формат, который принимает бэк
	convertDatetoRequest(date:Date){
    	return new Date(date).toISOString();
	}

	//функция для добавления пропущенных годов в список годов
	//public addMissingYears(yearlist:number[]){
	public addMissingYears(yearlist:number[]){

		for (let index = 0; index < yearlist.length; index++) {
			if(index>0){
				//получаем разницу между текущим и предыдущим
				let diff = yearlist[index] - yearlist[index-1];
				//если разница больше 1 то добаляем года по кол-ву
				if(diff > 1){
					let added = yearlist[index-1];
					for (let index = 0; index < diff-1; index++) {
						if(yearlist.indexOf(added + 1) == -1){
							yearlist.push(added + 1);
						}
						added +=1;
					}
				}
			}
		}
		let new_yearlist = yearlist.sort();
		return new_yearlist;
	}
}
